<template>
  <dialog class="dialog-modal-no-bg" aria-labelledby="file_info_modal_title">
    <div class="modal-dialog" role="document" style="color: #333333; outline: none;" ref="file_info_modal">
      <div class="modal-content">
        <div class="modal-header">
          <h2 style="font-size:1rem;" class="modal-title" id="file_info_modal_title">{{ this.file.file_name }}</h2>
          <button
              type="button"
              class="close"
              :aria-label="trans('lms.close')"
              @click="closeModal"
              tabindex="0"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div>
          <input type="hidden" name="fileId" :value="this.file.id"/>
          <div class="modal-body" style="color: #333333">
            <div class="description-container">
              <p class="description">{{ description }}</p>
            </div>
            <div class="tag-container padding-10-0">
              <p v-if="!max_accessibility">
                <span class="info">{{ trans("lms.Tags") }}: </span
                ><span
                  class="tag positive"
                  v-for="tag in tags"
                  :key="tag.hasOwnProperty('text') ? tag.text : tag"
              >{{ tag.hasOwnProperty("text") ? tag.text : tag }}</span
              >
              </p>
            </div>
            <p class="padding-10-0">
              <span class="info">{{ trans("lms.Uploaded") }}: </span>{{ uploaded }}
            </p>
            <p class="padding-10-0">
              <span class="info">{{ trans("lms.Author") }}: </span
              ><span v-html="getAuthor(author)"></span>
            </p>
            <p class="padding-10-0">
              <span class="info">{{ trans("lms.Size") }}: </span
              >{{ Math.ceil(size / 1024) }}KB
            </p>
          </div>
        </div>
      </div>
    </div>
  </dialog>
</template>
<script>
export default {
  props: ["show", "file", "masterdata", "max_accessibility"],
  data() {
    return {
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
      modalShown: this.show,
      description: "",
      input_empty: true,
      file_name: "",
      uploaded: "",
      author: "",
      size: "",
      tags: [],
    };
  },
  watch: {
    show(show) {
      if(show){
        this.$el.addEventListener('close', (e) => this.closeModal(e), { once: true });
        this.$el.showModal();
      }

      let date = this.file.created_at;
      let locale = document.documentElement.lang;
      if (locale == "en") {
        locale = "en-gb";
      }
      this.modalShown = show;
      this.description = show ? this.file.info.description : "";
      this.file_name = show ? this.file.name : "";
      this.uploaded = show ? this.formatDate(date) : "";
      this.author = show ? this.file.author_with_image : ""; // this.file.custom_properties.uploader_name : "";
      this.size = show ? this.file.size : "";
      this.tags = show ? this.file.tags : [];
      if (show) {
        setTimeout(
            () => {
              this.$refs.file_info_modal.focus();
            }, 200
        )
      }
    },
    description() {
      this.description ? (this.input_empty = false) : (this.input_empty = true);
    },
  },
  methods: {
    closeModal(e) {
      this.modalShown = false;
      this.description = "";
      this.file_name = "";
      this.uploaded = "";
      this.author = "";
      this.size = "";
      this.$emit("modal_closed");

      if(e.type != 'close') {
        this.$el.close();
      }
    },
    formatDate(date) {
      let newDate = new Date(date);
      if (isNaN(Date.parse(date))) {
        return date;
      }
      let locale = document.documentElement.lang;
      return newDate.toLocaleString(locale);
    },
    getAuthor(author) {
      return `<span> ${author} </span>`;
    },
  },
};
</script>
<style scoped>
.close {
  font-size: 2.3em;
}

.tag-container {
  display: flex;
}

.tag {
  /* background-color:var(--main-icon-color); */
  /* color: #fff; */
  border-radius: 2px !important;
  border: none !important;
  padding: 3px 5px;
  margin: 2px;
  font-size: 0.85em;
}

.label-form-container {
  position: relative;
}

.form-label {
  position: absolute;
  top: -3px;
  left: 27px;
  transition: all 0.2s ease-in;
  font-size: 0.8em;
}

.inputEmpty {
  top: 22px;
  left: 27px;
  font-size: 1em;
}

.transition {
  width: 80%;
  max-width: 600px;
  position: fixed;
  z-index: 500;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: none;
  animation-duration: 1s;
  animation-name: slidein;
}

@keyframes slidein {
  from {
    top: 5%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  to {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.transition .modal-dialog {
  margin-top: 0 !important;
}

.showModal {
  pointer-events: all;
  display: block;
}

#file_info_modal_title {
  max-width: 90%;
  float: left;
}

.modal-header {
  align-items: center;
}

/* .close {
  float: right;
  padding: 0 20px;
} */
.description-container {
  padding: 20px;
}

.description {
  text-align: center;
}

.modal-title {
  font-weight: bold;
}

.info {
  font-weight: bold;
}

.padding-10-0 {
  padding: 10px 0;
}

.modal-dialog {
  max-width: 100%;
}

@media screen and (max-width: 425px) {
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/fileinfo.vue